import { useContext } from 'react'

import KanbanColumnStatesContext from 'contexts/KanbanColumnStatesContext'

const useColumnStates = () => {
  const context = useContext(KanbanColumnStatesContext)
  if (!context)
    throw new Error(
      'useColumnStates must be used within KanbanColumnStatesProvider',
    )
  return context
}

export default useColumnStates
